import React from "react";
import { Flex } from "antd";
import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";
import { useNavigate } from "react-router-dom";
import { setModalOpen } from "@/reducers/commonSlice";
import { useDispatch } from "react-redux";

const GuideSubmitted = ({
  isOpen,
  message = "Successfully",
  subMessage = "",
  btnLabel = "Go to Dashboard",
  onSubmit = () => {},
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(setModalOpen(false));
    navigate("/dashboard");
  };
  const onContactUsClick = () => {
    dispatch(setModalOpen(false));
    navigate("/contact-us");
  };
  const handleExploreMembershipClick = () => {
    dispatch(setModalOpen(false));
    navigate("/membership");
  };
  return (
    <ModalComponent
      isOpen={isOpen}
      width={600}
      maskClosable={false}
      closeIcon={true}
      onCancelClick={() => {
        navigate("/");
      }}
    >
      <Flex
        vertical
        gap="1rem"
        align="center"
        style={{
          maxHeight: "min(800px, calc(100vh - 100px))",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <div
          className="icon-wrapper"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src="/assets/images/guideSubmit.svg"
            alt=""
            style={{
              width: "clamp(200px, 50%, 550px)",
              height: "auto",
              margin: "0 auto",
            }}
          />
        </div>
        <div className="body-b1 text-center">{"Guide Application Submitted Successfully!"}</div>
        <div className="body-b4 text-center">
          Thank you for your application. Your profile is currently under review, and we’ll notify
          you as soon as there are updates. <br />
          Meanwhile, enjoy full access to all student benefits as an Explorer member!
        </div>
        <Flex vertical gap="1rem" align="center">
          <div>
            <ButtonComponent label={btnLabel} type="primary" onClick={handleClick} />
          </div>
          <div>
            <ButtonComponent
              label={"Explore Membership Plans"}
              onClick={handleExploreMembershipClick}
            />
          </div>
          <span
            style={{
              color: "#db5800",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={onContactUsClick}
          >
            {"Contact us"}
          </span>
        </Flex>
      </Flex>
    </ModalComponent>
  );
};

export default GuideSubmitted;
